import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Row,
    Col
} from "antd";

import * as actions from "../actions";
import Forms from "./Forms";
import { GeneralStyledContent, StyledSearchForm } from "../../../../styled/common-styled";
import Breadcrumb from "./../../../shared/components/Breadcrumb";
import history from "../../../../lib/history";


class Add extends Component {

    create = (values, loading) => {
        //console.log("create", values)
        this.props.createTrip(values, loading, this.props.history);

    };


    render() {
        // const { dataPullvehiclesink, pullvehiclesinkLoading } = this.props.deliverytripState;
        return (
            <GeneralStyledContent>
                <Row gutter={24}>
                    <Col span={24}>
                        <Breadcrumb
                            match={this.props.match}
                            style={{ margin: "0px 0px 14px 10px" }}
                        />
                    </Col>
                </Row>
                <StyledSearchForm>
                    <Forms
                        onSubmit={this.create}
                        deliverytripState={this.props.deliverytripState}
                        vehicleLists={this.props.deliverytripState.vehicleLists}
                        producttypeLists={this.props.deliverytripState.producttypeLists}
                        driverLists={this.props.deliverytripState.driverLists}
                        loadVehicle={this.props.loadVehicle}
                        loadProducttype={this.props.loadProducttype}
                        loadDriver={this.props.loadDriver}
                        loading={this.props.deliverytripState.detailLoading}
                        selectedTrip={this.props.deliverytripState.selectedTrip}
                        trip_id={this.props.deliverytripState.trip_id}
                        check={this.props.deliverytripState.check}
                    />
                </StyledSearchForm>
            </GeneralStyledContent>
        );
    }
}

const mapStateToProps = ({
    deliverytripState,
}) => ({
    deliverytripState
});

const mapDispatchToProps = {
    createTrip: actions.createTrip.request,
    loadVehicle: actions.loadVehicle.request,
    loadProducttype: actions.loadProducttype.request,
    loadDriver: actions.loadDriver.request,
    clearList: actions.clearList
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Add);
